import { defineMessages, useIntl } from 'react-intl'
import { Flex, Text } from '@homebotapp/hb-react-component-catalog'
import { Listing, ListingCompact } from '../../../api/gqlaxy/gql/generated/graphql'

const MSG = defineMessages({
  likelyToNegotiate: {
    id: 'HomeSearch.likelyToNegotiateTag.label',
    defaultMessage: 'Likely to Negotiate'
  }
})

export interface LikelyToNegotiateTagProps {
  listing: ListingCompact | Listing
}

export const LikelyToNegotiateTag = ({ listing }: LikelyToNegotiateTagProps) => {
  const intl = useIntl()

  if (!listing?.likelyToNegotiate) {
    return null
  }

  return (
    <Flex
      alignItems='center'
      justifyItems='center'
      borderWidth={1}
      borderRadius={12}
      borderColor='brand.700'
      backgroundColor='brand.800'
      gap={2}
      px={2}
      py={0.5}
    >
      <Text margin={0} fontWeight={600} size='3xs' color='brand.50'>
        {intl.formatMessage(MSG.likelyToNegotiate)}
      </Text>
    </Flex>
  )
}
